import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=07b7f770&scoped=true&"
import script from "./OnboardingPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPage.vue?vue&type=style&index=0&id=07b7f770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7f770",
  null
  
)

export default component.exports